import { useIntl } from 'react-intl'

import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import ClearAllProductsFilters from 'app/features/Store/Products/components/ClearAllProductsFilters'
import ProductsFields from 'app/features/Store/Products/components/ProductsFields'

interface ProductsDesktopFilterProps {
  partNumbers?: string[]
}

const ProductsDesktopFilter: RFC<ProductsDesktopFilterProps> = ({
  partNumbers
}) => {
  const intl = useIntl()

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        display: { xs: 'none', md: 'flex' },
        minWidth: 230,
        width: 230,
        mt: 2
      }}
    >
      <Text variant="body2">
        {intl.formatMessage({ defaultMessage: 'Filters' })}
      </Text>

      <ProductsFields partNumbers={partNumbers} />

      <Box>
        <ClearAllProductsFilters />
      </Box>
    </Stack>
  )
}

export default ProductsDesktopFilter
